import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted } from "vue";

/** components */
import InputSearch from "@/components/common/globalSearch/inputSearch.vue";
import MenuSearch from "@/components/common/globalSearch/menuSearch/index.vue";
import { SEARCH_TYPE_ID } from "@/utils/constants";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onClickInputSearch"],
  setup(__props, { emit: emits }) {

const containerRef = ref<HTMLDivElement | null>(null);
const isFocus = ref(false);
const searchKey = ref("");
const searching = ref(0);
const lastCallApiValueSearch = ref("");
let valueSearch = "";



const onChangeSearchKey = (value: string) => {
  searchKey.value = value;
};

const closeMenu = () => {
  searchKey.value = "";
  isFocus.value = false;
};

const onfocusInputSearch = () => {
  valueSearch = searchKey.value;
  isFocus.value = true;
};

const onSearchInput = () => {
  searching.value += 1;
  if (searchKey.value && searchKey.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const closeInputSearch = () => {
  setTimeout(() => {
    if (searchKey.value !== valueSearch) searching.value += 1;
  }, 200);
  if (searchKey.value && searchKey.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const onClickOutside = (even: Event) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  const text = window.getSelection()?.toString() || "";
  if (text && searchKey.value.includes(text)) {
    return;
  }
  if (!containerRef.value?.contains(even.target as HTMLDivElement)) {
    closeMenu();
  }
};

const updateCurrentValueSearchKey = (value: any) => {
  searchKey.value = value;
};

const postAndGetRecentSearch = async () => {
  if (searchKey.value.trim() === "" || valueSearch === searchKey.value) return;
  lastCallApiValueSearch.value = searchKey.value;
  await store.dispatch("Assessment/postRecentSearchInput", {
    searchTypeId: SEARCH_TYPE_ID.GLOB,
    searchData: {
      text: searchKey.value,
    },
  });
  await store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.GLOB,
  });
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.CLOSE_GLOBAL_SEARCH, () => {
    closeMenu();
  });
});

watch(isFocus, () => {
  if (isFocus.value) {
    window.addEventListener("click", onClickOutside);
  } else {
    window.removeEventListener("click", onClickOutside);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "global-search-dropdown"
  }, [
    _createVNode(InputSearch, {
      "is-focus": isFocus.value,
      "search-key": searchKey.value,
      onFocus: onfocusInputSearch,
      onFocusout: closeInputSearch,
      onCloseMenu: closeMenu,
      onChangeSearchKey: onChangeSearchKey,
      onOnSearch: onSearchInput,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickInputSearch')))
    }, null, 8, ["is-focus", "search-key"]),
    _createVNode(MenuSearch, {
      "is-show": isFocus.value,
      searching: searching.value,
      "search-key": searchKey.value.trim(),
      onCloseMenu: closeMenu,
      onUpdateSearchKey: updateCurrentValueSearchKey
    }, null, 8, ["is-show", "searching", "search-key"])
  ], 512))
}
}

})